<template>
    <div class="main-right zcwj-content  index-active"
        style="margin: 0 auto; width: 939px;position: relative;top:115px;height: 600px;overflow:scroll;">
        <div class="cjcx" id="cjcx">
            <div class="tb form-table" style="width:300px;
                   text-align: center;">
                <div style="font-size: 14px;display: flex;height: 50px;line-height: 50px;">

                    <p style="width: 100px;font-weight: 600;">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</p>
                    <el-input style="margin-left: 15px;" v-model="userName" placeholder="请输入姓名"></el-input>
                </div>

                <div height="35" style="font-size: 14px;display: flex;height: 50px;line-height: 50px;">

                    <p style="width: 100px;font-weight: 600;"> 身份证号:</p>
                    <el-input style="margin-left: 15px;" v-model="idCard" placeholder="请输入身份证号"></el-input>
                </div>

                <!-- <div height="35" style="font-size: 14px;display: flex;height: 50px;line-height: 50px;">
                    <p style="width: 100px;font-weight: 600;"> 证书编号:</p>

                    <el-input style="margin-left: 15px;" v-model="CertificateNumber" placeholder="请输入准考证号">
                    </el-input>
                </div> -->
                <div style="display:flex">
                    <div height="35" style="font-size: 14px;display: flex;height: 50px;line-height: 50px;">
                        <p style="width: 100px;font-weight: 600;"> 验证码:</p>
                        <el-input style="margin-left: 15px;" v-model="verificationCode" placeholder="请输入验证码">
                        </el-input>
                    </div>
                    <div @click="refresh()">
                        <v-sidentify :identifyCode="identifyCode" style="width: 0px;cursor: pointer;"></v-sidentify>
                    </div>

                </div>
                <button type="button" class=" layui-btn layui-btn-sm" @click="inquire()">查询</button>
            </div>
            <div style="width: 800px;margin:0 auto">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="userName" label="姓名" width="auto" align="center">
                    </el-table-column>
                    <el-table-column prop="idCard" label="身份证" width="auto" align="center">
                    </el-table-column>

                    <el-table-column prop="certificatesType" label="证件类型" width="auto" align="center">
                    </el-table-column>


                    <el-table-column prop="occupationName" label="职业名称" width="auto" align="center">
                    </el-table-column>
                    <el-table-column prop="workTypeName" label="工种名称" width="auto" align="center">
                    </el-table-column>
                    <el-table-column prop="workTypeLevelStateAlias" label="等级" width="auto" align="center">
                    </el-table-column>



                    <el-table-column prop="ratingAgencies" label="评价机构" width="auto" align="center">
                    </el-table-column>
                    <el-table-column prop="certifyingAuthority" label="发证机构" width="auto" align="center">
                    </el-table-column>
                    

                    <el-table-column prop="certificateTime" label="发证日期" width="auto" align="center">
                    </el-table-column>

                    <!-- <el-table-column  label="操作" width="auto" align="center">
                        <template slot-scope="scope">
                            <span style="color: green;cursor: pointer;" @click="download(scope.row)">下载证书</span>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
        </div>
    </div>
</template>


<script>
    import Sidentify from './Sidentify';
    export default {
        name: 'app',
        components: {
            'v-sidentify': Sidentify
        },
        data() {
            return {
                userName: '',//姓名
                idCard: '',//身份证号
                CertificateNumber: '',//准考证号
                verificationCode: '', //验证码
                identifyCode: '1234', //随机验证码
                tableData: []
            }
        },
        created() {
            this.refresh();
        },
        mounted() {
        },
        methods: {
            download(item){

                const loading = this.$loading({
                        lock: true,
                        text: '请稍后...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                let parames = new URLSearchParams();
                parames.append('examId', item.examId);
                parames.append('userId', item.userId);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/ex/exportUserCertificate', parames).then(resp => {

                    
                    console.log(resp.data.fileName)

                    loading.close();

                    window.open(this.serverUrl + this.prefiexUrl + resp.data.fileName);

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
                
            },
            //验证码
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
            refresh() {
                this.identifyCode = '';
                for (let i = 0; i < 4; i++) {
                    this.identifyCode += this.randomNum(0, 10);
                }
            },
            //查询
            inquire() {
                if (this.userName === '') {
                    this.$message({
                        showClose: true,
                        message: '请填写姓名！',
                        type: 'warning'
                    })
                    return false;
                } else if (this.idCard === '') {
                    this.$message({
                        showClose: true,
                        message: '请填写身份证号！',
                        type: 'warning'
                    })
                    return false;

                } else if (this.verificationCode != this.identifyCode) {
                    this.$message({
                        showClose: true,
                        message: '请核对验证码！',
                        type: 'warning'
                    })
                    return false;
                }


                let parames = new URLSearchParams();
                parames.append('userName', this.userName);
                parames.append('idCard', this.idCard);
                parames.append('certificateNo', this.CertificateNumber);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/ex/selectCertificate', parames).then(resp => {
                    console.log(resp);
                    this.tableData = resp.data.data;

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })




            }

        }
    }
</script>


<style scoped>
    .code {
        width: 124px;
        height: 31px;
        border: 1px solid rgba(186, 186, 186, 1);
    }

    .login-code {
        cursor: pointer;
    }

    .laytable-cell-1-0-0 {
        width: 10%px;
    }

    .laytable-cell-1-0-1 {
        width: 25%px;
    }

    .laytable-cell-1-0-2 {
        width: 15%px;
    }

    .laytable-cell-1-0-3 {
        width: 15%px;
    }

    .laytable-cell-1-0-4 {
        width: 15%px;
    }

    .form-table td {
        padding: 5px 0;
    }

    .form-table td:first-child {
        width: 65px;
    }

    .form-input {
        width: 190px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 4px;
        color: #333;
    }

    .yzmBox {
        position: relative;
        width: 190px;
        margin: 0 auto;
        border-radius: 4px;
        overflow: hidden;
    }

    .yzmBox canvas {
        position: absolute;
        top: 0;
        right: 0;
        width: 90px;
        height: 100%;
        cursor: pointer
    }

    .content_title {
        padding-left: 25px;
        height: 35px;
        font-size: 14px;
        font-weight: bold;
        line-height: 33px;
    }

    .tb {
        margin: 50px auto;
        background-color: transparent;
        border-spacing: 0;
        border-collapse: collapse;
        margin-bottom: 15px;
    }

    .cjcx {
        margin: 0 auto;
        border: #DBDBDB 1px solid;
        border-top: 0;
        overflow: auto;
    }

    .zcwj-content {
        background-color: white;
        padding: 0 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/inquire/certificateInquire.vue